import { Component, OnInit, Input, SimpleChanges, ViewChild } from '@angular/core';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare var $: any;

@Component({
  selector: 'app-suggested-content',
  templateUrl: './suggested-content.component.html',
  styleUrls: ['./suggested-content.component.scss']
})
export class SuggestedContentComponent implements OnInit {

  @Input() whichSection;
  @Input() contentId;
  @Input() passRoute;
  userData: any;
  isError: boolean = false;
  slider: any;
  errorMessage: string;
  currentUser: any;
  imgURL: any = API_ENDPOINTS.BASE_URL;
  sliderActive = false;
  @Input() contentData;
  @ViewChild('owlCarousel', { static: false }) owlCarousel: any;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    autoWidth: true,
    dots: false,
    navSpeed: 500,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      },
      1199: {
        items: 5
      }
    },
    nav: true
  }
  constructor(
    private _authService: AuthService,
    private _router: Router,
  ) { }

  ngOnInit() {
    this.currentUser = this._authService.getCurrentUser();
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.contentData.currentValue.length > 2) {
  //     const _this = this;
  //     setTimeout(function(){
  //         _this.loadSlider();
  //     },500);
  //   }

  // }
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.contentData && changes.contentData.currentValue.length > 0 && changes.contentData.currentValue.length < 5) {
      this.customOptions.responsive['1199'].items = changes.contentData.currentValue.length;
      this.customOptions.loop = false;
    }else if(changes && changes.contentData && changes.contentData.currentValue.length >= 5){
      this.customOptions.loop = true;
      this.customOptions.responsive['1199'].items = 5;
    }
    if(this.contentId && this.whichSection === 'suggested'){
      this.owlCarousel.to(this.contentId);
    }
  }
  onContentSelect(id) {
    if (this._authService.isLoggednIn()) {
      if(this.passRoute){
        this._router.navigate(['/material-detail-page', id, 'public'], { queryParams: { whichRoute: 'dashboard', whichSection: 'suggested' } })
      } else {
        this._router.navigate(['/material-detail-page', id, 'public'])
      }
    }
    else {
      this._router.navigate(['/material-detail', id, 'public'])
    }
  }

  // slideNext() {
  //   this.slider.slick("slickNext");
  // }

  // slidePrevious() {
  //   this.slider.slick("slickPrev");
  // }

  // loadSlider() {
  //   this.slider = $(".data-slick-content").slick({
  //     centerMode: false,
  //     slidesToShow: 3,
  //     slidesToScroll: 3,
  //     autoplay: false,
  //     arrows: false,
  //     speed: 850,
  //     variableWidth: true,
  //     responsive: [
  //       {
  //         breakpoint: 1199,
  //         settings: {
  //           slidesToShow: 3,
  //           slidesToScroll: 3,
  //           infinite: true,
  //           dots: false,
  //           centerMode: false,
  //           centerPadding: '45px',
  //         }
  //       },
  //       {
  //         breakpoint: 991,
  //         settings: {
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
  //           centerMode: false,
  //           centerPadding: '15px',
  //           speed: 500,
  //         }
  //       }
  //     ]
  //   });
  //   this.slider.on('wheel', (function (e) {
  //     e.preventDefault();

  //     if (e.originalEvent.deltaY < 0) {
  //       $(this).slick('slickNext');
  //     } else {
  //       $(this).slick('slickPrev');
  //     }
  //   }));
  // }

  // initializeSlider() {
  //   const _this = this;
  //   if (this.contentData && this.contentData.length > 4) {
  //     setTimeout(() => {
  //       _this.owlCarousel.el.nativeElement.onwheel = function (e) {
  //         e.preventDefault();
  //         if (e.deltaY < 0) {
  //           _this.owlCarousel.next();
  //         } else {
  //           _this.owlCarousel.prev();
  //         }
  //         e.preventDefault();
  //       };
  //     }, 100);
  //   }
  // }

}
